module.exports = __webpack_public_path__ + "img/grey-academy-marketing.6334d746.png";